<!--
 * 消息提示框
 * 功能：显示消息提示框，点击确定按钮时，执行回调函数
 * param  {Object}  alertObj [消息提示框所需数据]
 * alertObj = {
    tipsMsg:'提示文案',
    confirmText: '确定按钮文案',
    callback: 点击确定按钮后的回调函数
  }
-->
<template>
  <div class="alert-tips-box" v-show="isShow">
    <div class="alert-tips-inner">
      <div class="tips-text">
        <div class="text" v-html="tipsMsg"></div>
      </div>
      <div class="tips-btn" v-if="confirmText && confirmText != ''">
        <button class="btn" @click="ClickConfirmButtonFun" v-html="confirmText"></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['alertObj'],
  data() {
    return {
      isShow: false, // 是否显示弹框
      tipsMsg: '', // 提示文案
      confirmText: '', // 确定按钮文案
      callback: '', // 回调函数
    };
  },
  methods: {
    // 关闭弹框的方法
    CloseNoticeTipsBoxFun: function () {
      this.isShow = false;
      this.$emit('update:alertObj', null);
    },
    // 点击确定按钮
    ClickConfirmButtonFun: function () {
      // 执行回调函数
      if (this.callback && typeof this.callback === 'function') {
        this.callback();
      }
      // 关闭弹框
      this.CloseNoticeTipsBoxFun();
    },
  },
  watch: {
    alertObj: function () {
      const obj = this.alertObj;
      const str = obj && obj.tipsMsg ? obj.tipsMsg.replace(/(^\s*)|(\s*$)/g, "") : '';
      if (str !== '') {
        this.tipsMsg = obj.tipsMsg ? obj.tipsMsg : '';
        this.confirmText = obj.confirmText ? obj.confirmText : '确定';
        this.callback = obj.callback ? obj.callback : null;
        this.isShow = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-tips-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.4);
  .alert-tips-inner {
    position: relative;
    top: 50%;
    width: 5rem;
    margin: 0 auto;
    padding: 0.6rem 0.35rem 0.48rem;
    transform: translateY(-40%);
    background: rgba(255, 255, 255, 1);
    border-radius: 0.22rem;
    .tips-text {
      font-size: 0.32rem;
      color: rgba(153, 153, 153, 1);
      line-height: 0.44rem;
      text-align: center;
    }
    .tips-btn {
      width: 2.38rem;
      height: 0.88rem;
      margin: 0.32rem auto 0;
      border-radius: 0.44rem;
      border: 0.02rem solid rgba(69, 139, 255, 1);
      font-size: 0.32rem;
      color: rgba(69, 139, 255, 1);
      line-height: 0.88rem;
      text-align: center;
      .btn {
        width: 100%;
        height: 100%;
        border-radius: 0.44rem;
        font-size: 0.32rem;
        color: rgba(69, 139, 255, 1);
        line-height: 0.88rem;
        text-align: center;
        outline: none;
        background: none;
        border: none;
      }
    }
  }
}
</style>
